import styled from '@emotion/styled';
import type { ReactNode } from 'react';

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export function FormSection({ children }: { children: ReactNode }) {
  return <Section>{children}</Section>;
}
